<template>
  <div id="appCalculateurUltime">
    <div class="cal__container" id="cal__app_container">
      <AppHeader />
      <AppBody />
      <AppFooterMobile v-if="this.$store.state.device === 'mobile'" />
      <AppFooter v-if="this.$store.state.device !== 'mobile'" v-bind:job="jobInfo" />
      <Modal v-if="showModal" v-bind:type="modalType" v-bind:job="jobInfo" />
    </div>
  </div>
</template>

<style>
  @import './assets/styles/normalize.css';
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap');
  @import './assets/styles/fonts.css';
  @import './assets/styles/main.css';
</style>

<script>

import AppHeader from './components/AppHeader.vue'
import AppBody from './components/AppBody.vue'
import AppFooterMobile from './components/AppFooterMobile.vue'
import AppFooter from './components/AppFooter.vue'
import Modal from './components/Modal.vue'

export default {
  name: "appCalculateurUltime",
  created () {
    this.$store.dispatch('fetchData');
    this.$store.dispatch('getDevice');
  },
  components: {
    AppHeader,
    AppBody,
    AppFooterMobile,
    AppFooter,
    Modal
  },
  computed: {
    jobInfo: function(){
      return this.$store.getters.jobInfo
    },
    showModal() {
      return this.$store.getters.showModal
    },
    modalType() {
      return this.$store.getters.modalType
    }
  }
}

</script>
